export enum PaymentMethod {
	YES_EVERYONE = 'YES_EVERYONE',
	YES_TARGET_AUDIENCE = 'YES_TARGET_AUDIENCE',
	NO = 'NO',
}
